import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-button-filter-table-clear',
  standalone: true,
  templateUrl: './button-filter-table-clear.component.html',
  imports: [MatIconModule,MatButtonModule,MatMenuModule,CommonModule,MatTooltipModule],
  styleUrl: './button-filter-table-clear.component.css',
})
export class ButtonFilterTableClearComponent { }
